module.exports = __webpack_public_path__ + "static/Predictive-Package-Sorting-And-Routing-b19f95d0950a7ac6a0b50010e5339618.jpg";